import React from 'react'
import styles from './LeadQualityScreen.module.css'
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface LeadRecommendationPopupContentProps {
    title?: string,
    subtext?: string,
    recommendation?: string,
    scoreType?: any,
}

const LeadRecommendationPopupContent: React.FC<LeadRecommendationPopupContentProps> = ({ title, subtext, recommendation, scoreType }) => {
    return (
        <div className={styles.LqsreacCont}>
            <div className={styles.LqsreacContTitle}>{title}</div>
            <div className={styles.LqsreacContSubtext}>{subtext}</div>
            <div className={`${styles.LqscsBanner} ${styles[scoreType]}`}>
                <span className={`${styles.LqscsBannerIcon} ${styles[scoreType]}`}>
                    {(scoreType == "good") && <ThumbUpIcon className={styles.ThumbUpIcon} />}
                    {(scoreType == "moderate") && <InfoOutlinedIcon className={styles.infoIcon} />}
                    {(scoreType == "poor") && <InfoOutlinedIcon className={styles.infoIcon} />}
                </span>
                {recommendation}
            </div>
        </div>
    )
}

export default LeadRecommendationPopupContent